import QRBarCodeBuilder from "./QRBarCodeBuilder";

export default QRBarCodeBuilder;
